import * as yup from 'yup';
import { Langue } from '../entities';

export const schemaLangue = yup.object<Partial<Langue>>({
    name: yup.string().required('Ce champ est requis'),
}) as yup.ObjectSchema<Partial<Langue>>;
